import heroImg from "../assets/product/img2.webp";
import heroBg from "../assets/product/pp1.webp";


export default function Hero() {
  const WHATSAPP_NUMBER = "919944949629"; // 🔴 replace with your number

  const openWhatsApp = () => {
    const message = `Hello Kaaliglobal,

I am interested in your premium Cardamom and Black Pepper products.
Please share details regarding pricing and availability.`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <section
      className="relative min-h-screen pt-28 md:pt-32 flex items-center bg-cover bg-center md:bg-fixed"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-white/95 via-white/75 to-white/40"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-5 md:px-6 grid md:grid-cols-2 gap-10 md:gap-16 items-center">

        {/* LEFT CONTENT */}
        <div className="animate-slideUp text-center md:text-left">
          <p className="uppercase tracking-widest text-[10px] md:text-xs text-gray-600 mb-3">
            Direct from Indian Farms
          </p>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-serif font-semibold mb-5 leading-tight text-black">
            Premium Indian <br className="hidden sm:block" /> Spices
          </h1>

          {/* Gold accent */}
          <div className="w-16 md:w-20 h-[2px] bg-[#c9a24d] mx-auto md:mx-0 mb-5"></div>

          <p className="text-gray-700 mb-8 max-w-md mx-auto md:mx-0 leading-relaxed text-sm md:text-base">
            Finest Idukki Black Pepper and Green Cardamom, carefully sourced
            and processed to preserve purity, aroma, and freshness for
            global markets.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="#products"
              className="w-full sm:w-auto bg-[#0a7d4f] text-white px-10 py-4 text-sm uppercase tracking-wide rounded-full hover:bg-[#086a43] transition"
            >
              View Products
            </a>

            <button
              onClick={openWhatsApp}
              className="w-full sm:w-auto border border-[#0a7d4f] text-[#0a7d4f] px-10 py-4 text-sm uppercase tracking-wide rounded-full hover:bg-[#0a7d4f] hover:text-white transition"
            >
              Contact Us
            </button>
          </div>

          {/* Subtle WhatsApp hint */}
          <p className="mt-4 text-[11px] text-gray-500 animate-pulse">
            💬 Get instant response on WhatsApp
          </p>
        </div>

        {/* RIGHT PRODUCT */}
        <div className="relative flex justify-center animate-float mt-8 md:mt-0">
          <img
            src={heroImg}
            alt="Kaaliglobal premium spices – cardamom and black pepper"
            loading="lazy"
            decoding="async"
            className="w-[200px] sm:w-[260px] md:w-full max-w-md drop-shadow-2xl"
          />
        </div>

      </div>

      {/* SCROLL INDICATOR */}
      <div className="hidden sm:flex absolute bottom-6 left-1/2 -translate-x-1/2 flex-col items-center text-gray-600 text-[10px]">
        <span className="mb-2 tracking-widest">SCROLL</span>
        <div className="w-[2px] h-8 bg-gray-400 relative overflow-hidden">
          <span className="absolute top-0 left-0 w-full h-4 bg-[#0a7d4f] animate-scrollLine"></span>
        </div>
      </div>

      {/* ANIMATIONS */}
      <style>
        {`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes float {
            0%,100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }

          @keyframes scrollLine {
            0% { transform: translateY(-100%); }
            100% { transform: translateY(200%); }
          }

          .animate-slideUp {
            animation: slideUp 0.9s ease-out forwards;
          }

          .animate-float {
            animation: float 6s ease-in-out infinite;
          }

          .animate-scrollLine {
            animation: scrollLine 1.8s infinite;
          }
        `}
      </style>
    </section>
  );
}
